module.exports = __webpack_public_path__ + "static/media/wpe1.png.1cfb5b3f.jpg";